import React from "react";
import { Container } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

const Dashboard = ({ t }) => {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            mainPath="/dashboard"
            path="/dashboard"
            title={t("Welcome")}
            breadcrumbItem={t("Dashboard")}
          />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Dashboard);
